import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Invoice } from '@models/invoice.model';
import { InvoiceServiceProvider } from '../../../../../shared/services/invoice/invoice-service/invoice.service';
import { IntegrationsDataProvider } from '../../../../../shared/services/integrations/integrations.data.service';
import { finalize } from 'rxjs/operators';
import { MessageService } from '../../../../../shared/services/helpers/message-service/message.service';
import { ConfirmGeneralModalComponent } from '@web-components/common/confirm-general-modal/confirm-general-modal.component';
import { SNModalService } from '@web-services/modal/snModal.service';

@Component({
	selector: 'copy-to-xero-btn',
	template: require('./copy-to-xero-btn.html'),
	styles: [require('./copy-to-xero-btn.scss')]
})
export class CopyToXeroBtnComponent implements OnInit {
	@Input() invoiceData: Invoice;
	@Output()
	successGetInvoiceInformation: EventEmitter<Invoice> = new EventEmitter();
	invoiceId: number;
	invoiceDisplayId: string;
	isBtnDisabled: boolean;

	constructor(
		private invoiceService: InvoiceServiceProvider,
		private integrationsDataService: IntegrationsDataProvider,
		private messageService: MessageService,
		private modalService: SNModalService
	) {}

	ngOnInit() {
		this.invoiceId = this.invoiceData.id;
		this.invoiceDisplayId = this.invoiceData.invoiceId;
	}

	copyToXero(): void {
		const { message } = this.invoiceData.actions.COPY_TO_XERO;
		if (message) {
			this.openAlertModal(message);
			return;
		}

		this.isBtnDisabled = true;

		if (!this.isInvoiceValid(this.invoiceData)) {
			this.integrationsDataService
				.copyInvoiceToXero(this.invoiceId)
				.pipe(finalize(() => (this.isBtnDisabled = false)))
				.subscribe(
					data => this.successCopyToXero(data),
					error => this.errorCopyToXero(error)
				);
		} else {
			this.isBtnDisabled = false;
		}
	}

	private isInvoiceValid(invoice: Invoice) {
		const dataToValidate = {
			packages: invoice.summary.items,
			pageName: 'invoicePage'
		};

		return dataToValidate.packages.some(packages =>
			this.invoiceService.isInvalidProduct(packages, dataToValidate.pageName)
		);
	}

	private successCopyToXero(data: Invoice): void {
		this.successGetInvoiceInformation.emit(data);
		this.messageService.showToaster('s_1', 'xero');
	}

	private errorCopyToXero({ data, status, error }): void {
		this.successGetInvoiceInformation.emit(null);

		if (error.errorCode) {
			this.handleModernErrorMessages(error);
			return;
		}

		const errorMessage = data ? data.errorMessage : null;
		let errorCode, errorPlace, value;
		if (errorMessage && status >= 400 && status < 500) {
			switch (errorMessage) {
				case "Paid or partially paid invoice can't be updated on Xero":
					errorCode = 'e_5';
					errorPlace = 'xero';
					break;
				case 'Invoice with such invoice ID (Invoice Number) exists on Xero':
					errorCode = 'e_6';
					errorPlace = 'xero';
					value = this.invoiceDisplayId;
					break;
				case 'Product/Package tax type is not compatible with Xero':
					errorCode = 'e_4';
					errorPlace = 'xero';
					break;
				case 'Fixed discount is not compatible with Xero':
					errorCode = 'e_1';
					errorPlace = 'xero';
					break;
				case 'Invoice is Voided or Deleted on Xero':
					errorCode = 'e_3';
					errorPlace = 'xero';
					break;
				case 'Invoice with written off payments is not compatible with Xero':
					errorCode = 'e_7';
					errorPlace = 'xero';
					break;
				case 'Xero access token expired, reconnect Xero please':
					errorCode = 'e_14';
					errorPlace = 'xero';
					break;
				case 'Bummer! Xero access token not authorized or revoked, reconnect Xero please':
					errorCode = 'e_14';
					errorPlace = 'xero';
					break;
				case 'Bummer! Xero access token revoked, reconnect Xero please':
					errorCode = 'e_14';
					errorPlace = 'xero';
					break;
				case "Bummer! You don't have an active Xero subscription.":
					errorCode = 'e_15';
					errorPlace = 'xero';
					break;
				default:
					errorCode = 'e_2';
					errorPlace = 'general';
					value = errorMessage;
			}
		} else {
			errorCode = 'e_0';
			errorPlace = 'general';
		}
		this.messageService.showToaster(errorCode, errorPlace, value);
	}

	private openAlertModal(message: string): void {
		const modal = this.modalService.openModal(ConfirmGeneralModalComponent, {
			windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
		});
		modal.componentInstance.text = message;

		modal.componentInstance.buttons = [
			{
				text: 'Okay',
				action: 'CLOSE',
				color: 'default',
				size: 'lg'
			}
		];
	}

	private handleModernErrorMessages({ errorTitle, errorMessage }): void {
		this.messageService.showErrorFromBackend(errorTitle, errorMessage);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/buttons/copy-to-xero-btn/copy-to-xero-btn.ts